<div class="renderer-container" (click)="$event.stopPropagation()">
  <mat-checkbox [(ngModel)]="checked"
                (change)="update()"
  ></mat-checkbox>
</div>
